import { Button, LogOutIcon, Typography } from '@/components/atoms';
import { useTranslation, useUIColors } from '@/core/hooks';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export interface LogoutSuccessScreenProps {
    onGoToLogin?: () => void;
}

export function LogoutSuccessScreen({ onGoToLogin }: LogoutSuccessScreenProps) {
    const colors = useUIColors();
    const { t } = useTranslation();
    const insets = useSafeAreaInsets();

    const styles = StyleSheet.create({
        container: {
            flex: 1,
            backgroundColor: colors.backgroundLevel1,
        },
        content: {
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
        },
        mainContent: {
            alignItems: 'center',
            gap: 32,
        },
        illustrationContainer: {
            alignItems: 'center',
            justifyContent: 'center',
            width: 88,
            height: 88,
        },
        textContainer: {
            alignItems: 'center',
            gap: 0,
        },
        title: {
            textAlign: 'center',
            fontSize: 28,
            fontWeight: '500',
            lineHeight: 34,
        },
        buttonContainer: {
            width: '100%',
            paddingBottom: Math.max(insets.bottom, 20),
            paddingHorizontal: 16,
        },
    });

    return (
        <View style={styles.container}>
            <View style={styles.content}>
                <View style={styles.mainContent}>
                    <View style={styles.illustrationContainer}>
                        <LogOutIcon size={88} color={colors.fontPrimary} strokeWidth={3.5} />
                    </View>
                    <View style={styles.textContainer}>
                        {t('profile.loggedOutSuccessfully')
                            .split('\n')
                            .map((line, index) => (
                                <Typography
                                    key={index}
                                    variant="title1"
                                    color="primary"
                                    style={styles.title}
                                >
                                    {line}
                                </Typography>
                            ))}
                    </View>
                </View>
            </View>
            <View style={styles.buttonContainer}>
                <Button
                    title={t('profile.goToLogin')}
                    variant="primary"
                    onPress={onGoToLogin}
                    fullWidth
                />
            </View>
        </View>
    );
}

